export default "__VITE_ASSET__BEbwPAkF__"